/** `path` ready for one more query parameter: `?` if it has none yet, `&`
 *  if it already carries some. An OAuth error-return path can arrive with a
 *  query (the onboarding returns to `/onboarding?next=…` so a pending deep
 *  link survives a failed sign-in), and a blind `?` would corrupt it. */
export function withQuery(path: string): string {
  return path + (path.includes("?") ? "&" : "?");
}
